module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/339c155417f00f3c8f34a1e04fa8636f.png";